import IntentStatistics from './IntentStatistics';

export default IntentStatistics;
